module.exports = require("./lg.js");